/* eslint no-unused-vars: 1 */

(function() {
    'use strict';
    angular.module('shopAuth').service('mnpCookieService', [ '$injector', 'cookieService', function($injector, cookieService) {

        var config = $injector.get('config');

        var cookieDefaultData = {
            MSISDN: null,
            orderId: null,
        };

        /**
         * create MNP Cookie with given data, if not given with default data
         */
        function create(data) {
            data = data || cookieDefaultData;
            cookieService.setCookie(config.MNPCOOKIE.NAME, JSON.stringify(data), config.MNPCOOKIE.TTL);
        }

        /**
         * get complete MNP Cookie
         */
        function get() {
            var data = JSON.parse(cookieService.getCookie(config.MNPCOOKIE.NAME));
            return data;
        }

        /**
         * destroy MNP Cookie
         */
        function kill() {
            return cookieService.killCookie(config.MNPCOOKIE.NAME);
        }

        /**
         * set a value in current MNP cookie if cookie not exists, it will be created
         */
        function setValue(key, value) {
            var data = get() || cookieDefaultData;
            data[key] = value;
            create(data);
        }

        /**
         * get a single value from MNP Cookie or null if not exist
         */
        function getValue(key) {
            var data = get();
            if (data && data[key]) {
                return data[key];
            }
            return null;
        }

        return {
            create: create,
            get: get,
            kill: kill,
            setValue: setValue,
            getValue: getValue
        };
    }
    ]);
}());